import { Box, BoxProps, Button, ButtonGroup, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import {
    ChevronLeft,
    ChevronRight,
    FirstPage,
    LastPage
} from '@mui/icons-material';

type PaginatorProps = {
    currentPage?: number;
    totalRecords: number;
    onPageChange: (page: number) => void;
    pageSize?:number
    onPageSizeChange: (pageSize: number) => void;
    parentBoxProps?: BoxProps;
}

const TOTAL_PAGES_BUTTON = 5;
const PAGE_SIZES = [5, 10, 20, 50, 100];

const Paginator = ({ currentPage = 1, totalRecords, onPageChange, pageSize = 10, onPageSizeChange, parentBoxProps }: PaginatorProps) => {
    const [pageSizeState, setPageSizeState] = useState<number>(pageSize);
    const [totalPages, setTotalPages] = useState<number>(Math.ceil(totalRecords / pageSize));

    useEffect(() => {
        setTotalPages(Math.ceil(totalRecords / pageSizeState));
    }, [totalRecords, pageSizeState]);

    const handlePageSizeChange = (page: number) => {
        setPageSizeState(page);
        onPageSizeChange(page);
        onPageChange(1);
    }

    const getVisiblePages = (currentPage) => {
        const half = Math.floor(TOTAL_PAGES_BUTTON / 2);
        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, start + TOTAL_PAGES_BUTTON - 1);
        if (end - start + 1 < TOTAL_PAGES_BUTTON) {
            start = Math.max(1, end - TOTAL_PAGES_BUTTON + 1);
        }
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    return (<Box sx={{width:"100%"}} display='grid' gridTemplateColumns='1fr auto' alignItems='center' px={2} {...parentBoxProps}>
        <Box display='flex' justifyContent='center'  sx={{width:"90%"}}>
            <ButtonGroup variant='outlined'>
                <Button onClick={() => onPageChange(1)} disabled={currentPage === 1}>
                    <FirstPage/>
                </Button>
                <Button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                    <ChevronLeft/>
                </Button>
                {getVisiblePages(currentPage).map((page) => (
                    <Button key={page} onClick={() => onPageChange(page)} color='primary' variant={page === currentPage ? 'contained' : 'outlined'}>
                        {page}
                    </Button>
                ))}
                <Button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    <ChevronRight/>
                </Button>
                <Button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
                    <LastPage/>
                </Button>
            </ButtonGroup>
        </Box>
        <Select
        value={pageSizeState}
        onChange={(e) => handlePageSizeChange(e.target.value as number)}
        sx={{width: 80, position: "relative", right: 0}}>
            {PAGE_SIZES.map((size) => (
                <MenuItem key={size} value={size}>
                    {size}
                </MenuItem>
            ))}
        </Select>
    </Box>);
}

export default Paginator;